import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = ({ children }) => {
  return (
    <>
      <div className="app-bg" />
      <div className="app-grid" />
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
    </>
  );
};
